import {Component, OnInit} from '@angular/core';
import {MenuButtonsPageComponent} from '../../shared/components/menu-buttons-page/menu-buttons-page.component';
import {Router} from '@angular/router';
import {LangService} from '../../core/services/lang.service';
import {RecommendationsService} from '../../core/api/recommendations.service';
import {getRecommendationTitle, Recommendation, Recommendations} from '../../shared/models/recommendations.model';

@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  imports: [MenuButtonsPageComponent],
})
export class RecommendationsComponent implements OnInit {

  backgroundImage = '/images/recommendations.png';

  topActions: TopAction[] = [];

  constructor(private router: Router, private recommendationsService: RecommendationsService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.loadRecommendations();
  }

  public loadRecommendations() {
    this.recommendationsService.getRecommendations().subscribe({
      next: (recommendations: Recommendations) => {
        this.topActions = recommendations.map((recommendation: Recommendation) => ({
          id: getRecommendationTitle(recommendation),
          label: getRecommendationTitle(recommendation),
          href: `/recommendations/${recommendation.id}`,
        }));
      },
      error: (error) => {
        console.error('Error al obtener recomendaciones:', error);
      }
    });
  }

  onActionClick(action: TopAction) {
    if (action.href) {
      const id = action.href.split('/').pop();
      if (id) {
        this.router.navigate(['/recommendations', id]);
      }
    }
  }
}
